module.exports = __webpack_public_path__ + "static/media/bfile-death-benefit.f83969be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/bfile-death-benefit.svg
// module id = 3121
// module chunks = 0